import { footerLinkStyle, linkStyle } from "@/styles/sharedStyle";
import { Font, Icon } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";
import config from "@/libs/config";

type Props = { regist?: boolean };

export const SpecialTermsLink = (props: Props) => {
  return (
    <>
      <Font variant="m" component="span">
        {props.regist ? `${config.BANK_FORMAL_NAME}への` : null}
      </Font>
      <a
        css={props.regist ? linkStyle : footerLinkStyle}
        href="/terms/policy_data_provision"
        target="_blank"
      >
        <Font variant="m" component="span">
          利用者情報の第三者提供に関する特約
        </Font>
        {props.regist ? (
          <Font variant="m" component="span">
            {" "}
            <Icon css={icon} name="openInNew" size="sm" />{" "}
          </Font>
        ) : null}
      </a>
      {props.regist ? (
        <Font variant="m" component="span">
          に同意する
        </Font>
      ) : null}
    </>
  );
};
const icon = css({
  cursor: "pointer",
  margin: "4px",
});
